module.exports = __webpack_public_path__ + "img/prg-big-2.1ef9c674.jpg";